module.exports = __webpack_public_path__ + "media/images/hero-d951bb4b0ad41537c6346dc229c782b9.jpg";